export const modalVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: {
    opacity: 0,
    when: 'afterChildren',
    duration: { delay: 1 }
  }
};

export const contentVariants = {
  hidden: {
    height: 0,
    opacity: 0
  },
  visible: {
    opacity: 1,
    height: 'max-content',
    transition: { duration: 0.5, delay: 0.5 }
  },
  exit: {
    opacity: 0,
    height: 0
  }
};
